import React from 'react';

import Page from '@Containers/Page';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { LinkElement } from '@els/els-react--link-element';

import './DNSMaintenance.scss';

function DNSMaintenance() {
  return (
    <Page
      withHeader
      headerType="clean"
      withFooter
      pageClassName="react-page-static dns-maintenance-page"
      className="react-page-static__wrapper">
      <div className="dns-maintenance-page__header page-container--hexagons rx-left-gutter rx-right-gutter">
        <h1 className="u-els-padding-top-1x u-els-padding-bottom-1x u-els-font-size-h2">www.reaxys.com</h1>
        <p className="dns-maintenance-page__header_text u-els-margin-bottom-2x u-els-font-size-base">
          We apologise for the inconvenience but Reaxys no longer supports the URL that you have used. <br />
          Please use
          <LinkElement href="https://www.reaxys.com" padded="one-of-two" isExternal noExternalIcon a11y="Link to Reaxys">
            https://www.reaxys.com
          </LinkElement>
          to reach Reaxys and please update your bookmarks.
          <br />
          The following is a list of URLs that are no longer supported or have been configured to redirect to
          <LinkElement href="https://www.reaxys.com" padded="one-of-two" isExternal noExternalIcon a11y="Link to Reaxys">
            https://www.reaxys.com
          </LinkElement>
          <br />
          Please contact our support team if you have any questions
        </p>
      </div>
      <div className="react-page-static__content rx-left-gutter rx-right-gutter">
        <div className="dns-maintenance-page__links">
          <div className="dns-maintenance-page__links_block">
            <span>Reaxys obsolete names</span>
            <span>acert-www.reaxys.com</span>
            <span>alt-www.reaxys.com</span>
            <span>www-ipacl.reaxys.com</span>
          </div>
          <div className="dns-maintenance-page__links_block">
            <span>Reaxys redirects to www.reaxys.com</span>
            <span>reaxys.com</span>
            <span>batch-www.reaxys.com</span>
            <span>beta.reaxys.com</span>
            <span>cn-www.reaxys.com</span>
            <span>fl-www.reaxys.com</span>
            <span>www.inspiringchemistry.reaxys.com</span>
            <span>new-cert.reaxys.com</span>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default withCombinedRouteParams(DNSMaintenance);
